import { CardCvcElement } from '@stripe/react-stripe-js'
import createInput from './utils'

export const CardCVCInput = createInput(CardCvcElement)
